import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { CREATE_EDIT_TRUCK_ROUTE_FORM_NAME } from 'Common/FormEnum';
import { CreateEditTruckRouteEnum } from 'Common/FieldEnum';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import {
  TruckRouteTypeEnum,
  AssignTypeEnum,
} from 'Common/Constants/Enumeration/TruckRouteEnum';

import CreateEditTruckRouteComponent from './../../components/createedittruckroute/CreateEditTruckRoute';

class CreateEditTruckRouteContainer extends Component {
  static propTypes = {
    bidGroupOptions: PropTypes.array,
    itemGroupOptions: PropTypes.array,
    acctCategoryOptions: PropTypes.array,
    vendorDataOptions: PropTypes.array,
    storageLocationDataOptions: PropTypes.array,
    siteGroupDataOptions: PropTypes.array,
    fetchingDropdown: PropTypes.bool,
    siteData: PropTypes.array.isRequired,
    initialSelectedSites: PropTypes.array,
    initialSelectedVendors: PropTypes.array,
    siteItems: PropTypes.array.isRequired,
    siteItemsLoading: PropTypes.bool,
    getMainProps: PropTypes.func,
    routeName: PropTypes.string,
    isNew: PropTypes.bool,
    id: PropTypes.string,
    truckRouteType: PropTypes.number,
    assignType: PropTypes.number,
    vendorTableData: PropTypes.array,
    vendorItemIdsLoading: PropTypes.bool,
    vendorTableDataLoading: PropTypes.bool,
    truckRouteAssignmentTypesOptions: PropTypes.array,
    truckRouteTypesOption: PropTypes.array,
    clearSiteItems: PropTypes.func,
  };
  static defaultProps = {
    bidGroupOptions: [],
    itemGroupOptions: [],
    acctCategoryOptions: [],
    vendorDataOptions: [],
    storageLocationDataOptions: [],
    siteGroupDataOptions: [],
    fetchingDropdown: false,
    initialSelectedSites: [],
    initialSelectedVendors: [],
    siteItemsLoading: false,
    getMainProps: () => {},
    routeName: '',
    isNew: false,
    id: 0,
    truckRouteType: TruckRouteTypeEnum.Delivery,
    assignType: AssignTypeEnum.Sites,
    vendorTableData: [],
    vendorItemIdsLoading: false,
    vendorTableDataLoading: false,
    truckRouteAssignmentTypesOptions: [],
    truckRouteTypesOption: [],
    clearSiteItems: () => {},
  };
  state = {
    activeIndexes: [],
    checked: false,
    siteGroupId: GenericEnum.InitialFilterValue,
    bidGroupId: GenericEnum.InitialFilterValue,
    itemGroup: GenericEnum.InitialFilterValue,
    vendorId: GenericEnum.InitialFilterValue,
    storageLocationId: GenericEnum.InitialFilterValue,
    accountCategory: GenericEnum.InitialFilterValue,
    filtered: [],
  };

  handleChange = (e, currentValue, prevVal, field) => {
    const fieldName = field.replace(field[0], field[0].toLowerCase());
    this.setState({ [fieldName]: currentValue });
  };
  toggle = () => {
    this.setState(prevState => ({ checked: !prevState.checked }));
  };

  onFilteredChange = (filtered, column) => {
    this.setState({ filtered });
  };

  clearFilters = () => {
    const { change } = this.props;
    change(CreateEditTruckRouteEnum.BidGroupId, GenericEnum.InitialFilterValue);
    change(CreateEditTruckRouteEnum.ItemGroup, GenericEnum.InitialFilterValue);
    change(CreateEditTruckRouteEnum.VendorId, GenericEnum.InitialFilterValue);
    change(
      CreateEditTruckRouteEnum.AccountCategory,
      GenericEnum.InitialFilterValue
    );
    change(
      CreateEditTruckRouteEnum.StorageLocationId,
      GenericEnum.InitialFilterValue
    );
    this.setState({
      bidGroupId: GenericEnum.InitialFilterValue,
      itemGroup: GenericEnum.InitialFilterValue,
      vendorId: GenericEnum.InitialFilterValue,
      storageLocationId: GenericEnum.InitialFilterValue,
      accountCategory: GenericEnum.InitialFilterValue,
      filtered: [],
    });
  };
  handleCollapsePanelClick = (e, titleProps) => {
    const { index } = titleProps;
    const cloneActiveIndexes = _.clone(this.state.activeIndexes);
    cloneActiveIndexes.indexOf(index) !== -1
      ? cloneActiveIndexes.splice(cloneActiveIndexes.indexOf(index), 1)
      : cloneActiveIndexes.push(index);
    this.setState({ activeIndexes: cloneActiveIndexes });
  };
  handleAssignTypeChange = (event, newValue, previousValue, name) => {
    this.clearTypeValues();
  };
  onChangeTypeOption = () => {
    this.clearTypeValues();
    this.props.change(
      CreateEditTruckRouteEnum.AssignType,
      AssignTypeEnum.Sites
    );
  };
  clearTypeValues = () => {
    const {change, clearSiteItems } = this.props;
    change(CreateEditTruckRouteEnum.SiteIds, []);
    change(CreateEditTruckRouteEnum.ItemIds, []);
    change(CreateEditTruckRouteEnum.VendorIds, []);
    clearSiteItems();
  };
  render() {
    const {
      bidGroupOptions,
      itemGroupOptions,
      acctCategoryOptions,
      vendorDataOptions,
      storageLocationDataOptions,
      siteGroupDataOptions,
      fetchingDropdown,
      siteData,
      initialSelectedSites,
      initialSelectedVendors,
      siteItems,
      siteItemsLoading,
      getMainProps,
      routeName,
      isNew,
      id,
      truckRouteType,
      assignType,
      vendorTableData,
      vendorItemIdsLoading,
      vendorTableDataLoading,
      truckRouteAssignmentTypesOptions,
      truckRouteTypesOption,
    } = this.props;
    const {
      siteGroupId,
      bidGroupId,
      itemGroup,
      vendorId,
      storageLocationId,
      accountCategory,
      filtered,
    } = this.state;
    return (
      <CreateEditTruckRouteComponent
        getBreadCrumbs={this.props.getBreadCrumbs}
        activeIndexes={this.state.activeIndexes}
        handleCollapsePanelClick={this.handleCollapsePanelClick}
        bidGroupOptions={bidGroupOptions}
        itemGroupOptions={itemGroupOptions}
        acctCategoryOptions={acctCategoryOptions}
        vendorData={vendorDataOptions}
        storageLocationData={storageLocationDataOptions}
        fetchingDropdown={fetchingDropdown}
        checked={this.state.checked}
        toggle={this.toggle}
        handleChange={this.handleChange}
        filtered={filtered}
        onFilteredChange={this.onFilteredChange}
        siteGroupId={siteGroupId}
        bidGroupId={bidGroupId}
        itemGroup={itemGroup}
        vendorId={vendorId}
        storageLocationId={storageLocationId}
        accountCategory={accountCategory}
        siteGroupDataOptions={siteGroupDataOptions}
        siteData={siteData}
        clearFilters={this.clearFilters}
        initialSelectedSites={initialSelectedSites}
        initialSelectedVendors={initialSelectedVendors}
        siteItems={siteItems}
        siteItemsLoading={siteItemsLoading}
        getMainProps={getMainProps}
        routeName={routeName}
        isNew={isNew}
        id={id}
        onChangeTypeOption={this.onChangeTypeOption}
        truckRouteType={truckRouteType}
        handleAssignTypeChange={this.handleAssignTypeChange}
        assignType={assignType}
        vendorTableData={vendorTableData}
        vendorItemIdsLoading={vendorItemIdsLoading}
        vendorTableDataLoading={vendorTableDataLoading}
        truckRouteAssignmentTypesOptions={truckRouteAssignmentTypesOptions}
        truckRouteTypesOption={truckRouteTypesOption}
      />
    );
  }
}
const validate = (values, props) => {
  const errors = {};
  if (
    !values[CreateEditTruckRouteEnum.RouteName] ||
    _.trim(values[CreateEditTruckRouteEnum.RouteName]).length === 0
  ) {
    errors[CreateEditTruckRouteEnum.RouteName] = 'Name is required.';
  }

  return errors;
};
export const CreateEditTruckRoute = reduxForm({
  form: CREATE_EDIT_TRUCK_ROUTE_FORM_NAME,
  enableReinitialize: true,
  validate,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(CreateEditTruckRouteContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/containers/createedittruckroute/CreateEditTruckRoute.js